import { WidgetType } from "@codemirror/view";

export class TableRenderingErrorWidget extends WidgetType {
    constructor(tableNode) {
        super();
        this.hasTableNode = Boolean(tableNode);
    }

    toDOM() {
        const warning = document.createElement("div");
        warning.classList.add("notification", "notification-type-info");
        warning.role = "alert";

        const icon = document.createElement("div");
        icon.classList.add("notification-icon");
        icon.textContent = "i";
        warning.appendChild(icon);

        const messageWrapper = document.createElement("div");
        messageWrapper.classList.add("notification-content-and-cta");

        const message = document.createElement("div");
        message.classList.add("notification-content");

        const messageHeader = document.createElement("p");
        const strong = document.createElement("strong");
        strong.textContent = "This table can't be displayed right now.";
        messageHeader.appendChild(strong);

        const messageBody = document.createElement("p");
        messageBody.textContent = "Some table elements are not supported by the visual renderer yet.";

        message.appendChild(messageHeader);
        message.appendChild(messageBody);
        messageWrapper.appendChild(message);
        warning.appendChild(messageWrapper);

        const element = document.createElement("div");
        element.classList.add("table-generator", "table-generator-error-container");
        element.appendChild(warning);
        if (this.hasTableNode) {
            element.classList.add("ol-cm-environment-table");
        }
        return element;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
